<template>
  <div>
    <StepHeader title="Do You Have a Trade In?"/>
    <StepContent
      width="xl"
    >
      <AppButtonList
        :columns="3"
        :buttons="buttons"
        :value="currently_driving"
        @input="handleClick($event)"
      />
    </StepContent>

    <StepFooter>
      <AppButtonContinue
        v-data-layer="handleDataLayer"
        @click="$emit('next')"
      >
        Continue
      </AppButtonContinue>
    </StepFooter>
  </div>
</template>

<script>
import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'
import AppButtonList from '@/components/common/buttons/AppButtonList'
import StepContent from '@/components/common/step/StepContent'
import StepFooter from '@/components/common/step/StepFooter'
import StepHeader from '@/components/common/step/StepHeader'
import StepTooltip from '@/components/common/step/StepTooltip'
import DataLayer from '../../../../data-layer'

export default {
  name: 'currently-driving',

  components: {
    AppButtonContinue,
    AppButtonList,
    StepContent,
    StepFooter,
    StepHeader,
    StepTooltip
  },

  data () {
    return {
      datalayerStepName: 'currently_driving',
      fieldName: 'currently_driving',
      defaultSelected: true,
      buttons: [{
        text: 'Yes',
        value: 'Yes, they have a trade in',
        datalayer: 'trade_in_yes'
      }, {
        text: 'No',
        value: "No, they don't have a trade in",
        datalayer: 'trade_in_no'
      }, {
        text: 'Unsure',
        value: 'Unsure on trade in',
        datalayer: 'trade_in_unsure'
      }]
    }
  },

  computed: {
    currently_driving () {
      return this.$store.state.application[this.fieldName]
    }
  },

  // Created
  created () {
    if (!this.currently_driving) {
      this.$store.updateApplication(
        this.fieldName,
        this.buttons[0].value
      )
    } else {
      this.defaultSelected = false
    }
  },

  methods: {
    handleClick (event) {
      this.$store.updateApplication(this.fieldName, event)
      this.defaultSelected = false
    },
    handleDataLayer () {
      DataLayer.track({
        event: 'gpa_step_completed',
        step: '4',
        has_trade_in: this.currently_driving
      })
    }
  }
}
</script>

<style>
</style>
